var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"catalogue-product-informations-item",class:_vm.classes},[_c('ToggleSwitcher',{attrs:{"model":_vm.toggled},on:{"change":_vm.emitData}}),_vm._v(" "+_vm._s(_vm.data.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }